import React from "react";
import { FormattedMessage } from "react-intl";
import type { Campaign, ICampaignAbstract } from "./objects/Campaign";
import {
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";
import { CountryCodeName } from "src/shared/formatters/CountryFormatter";
import { Formatter } from "src/shared/formatters/Formatter";

export const CampaignsLabel = (props: IRaangeLabelWithFAProps) => (
  <RaangeLabel fa="bullhorn" {...props}>
    <FormattedMessage id="campaigns" />
  </RaangeLabel>
);

export interface ICampaignFormatterProps extends IRaangeLabelWithFAProps {
  children: Campaign;
}

export interface ICampaignNameProps extends IRaangeLabelWithFAProps {
  children: ICampaignAbstract;
}

export const CampaignName = ({ children, ...rest }: ICampaignNameProps) => (
  <RaangeLabel fa="bullhorn" {...rest}>
    {children.campaignName}
  </RaangeLabel>
);

export const CampaignCreate = (props: IRaangeLabelWithFAProps) => (
  <RaangeLabel fa="plus" {...props}>
    <FormattedMessage id="campaigns.create" />
  </RaangeLabel>
);

export const CampaignEdit = (props: ICampaignFormatterProps) => (
  <RaangeLabel fa="pencil-alt" {...props}>
    <FormattedMessage id="campaigns.edit" />
  </RaangeLabel>
);

export const CampaignDispatches = ({
  children,
  ...rest
}: ICampaignNameProps) => {
  return (
    <RaangeLabel fa="bullhorn" {...rest}>
      {children.campaignName}
    </RaangeLabel>
  );
};

export const CampaignCountry = ({
  children: campaign,
}: ICampaignFormatterProps) => {
  if (!campaign.countryCode) {
    return <Formatter>{null}</Formatter>;
  }
  return <CountryCodeName>{campaign.countryCode}</CountryCodeName>;
};
